module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Rose Gold Aluminum + Midnight Blue Closed.be938276.png";